import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Zap, Plus, Trash2, Settings2, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { api } from "../lib/api";

const Manage = ({ open, onOpenChange, items, onSaved }) => {
  const [list, setList] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setList(items.map((x) => ({ ...x }))); }, [open, items]);
  const upd = (i, k, v) => setList((p) => p.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  const save = async () => {
    setBusy(true);
    try { const r = await api.saveOutlookQuickReplies(list); onSaved(r.items); toast.success("تم حفظ الردود الجاهزة"); onOpenChange(false); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg font-body max-h-[88vh] overflow-y-auto" dir="rtl" data-testid="quick-replies-dialog">
        <DialogHeader><DialogTitle>الردود الجاهزة</DialogTitle>
          <DialogDescription>استخدم {"{الاسم}"} ليُستبدل تلقائياً باسم مرسل الإيميل.</DialogDescription></DialogHeader>
        <div className="space-y-3">
          {list.map((x, i) => (
            <div key={x.id || i} className="rounded-xl border border-slate-200 p-2.5 space-y-2" data-testid={`quick-reply-edit-${i}`}>
              <div className="flex gap-2">
                <Input data-testid={`quick-reply-title-${i}`} value={x.title} onChange={(e) => upd(i, "title", e.target.value)} placeholder="العنوان (مثال: إغلاق الحساب)" className="h-9" />
                <button onClick={() => setList((p) => p.filter((_, j) => j !== i))} className="text-slate-400 hover:text-rose-600" data-testid={`quick-reply-del-${i}`}><Trash2 className="h-4 w-4" /></button>
              </div>
              <Textarea data-testid={`quick-reply-text-${i}`} rows={3} value={x.text} onChange={(e) => upd(i, "text", e.target.value)} placeholder="نص الرد" />
            </div>
          ))}
          <Button variant="outline" size="sm" data-testid="quick-reply-add" onClick={() => setList((p) => [...p, { title: "", text: "" }])} className="gap-1"><Plus className="h-4 w-4" /> رد جديد</Button>
        </div>
        <DialogFooter><Button data-testid="quick-replies-save" disabled={busy} onClick={save}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "حفظ"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const QuickReplies = ({ senderName, onPick }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.outlookQuickReplies().then((r) => setItems(r.items)).catch(() => {}); }, []);
  const fill = (txt) => txt.replace(/\{الاسم\}/g, senderName || "");
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="quick-replies">
      <span className="flex items-center gap-1 text-xs font-bold text-amber-700"><Zap className="h-3.5 w-3.5" /> ردود جاهزة:</span>
      {items.map((x) => (
        <button key={x.id} type="button" data-testid={`quick-reply-${x.id}`} onClick={() => onPick(fill(x.text))}
          className="rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-[11px] font-semibold text-amber-800 transition-colors hover:bg-amber-100">{x.title}</button>
      ))}
      <button type="button" data-testid="quick-replies-manage" onClick={() => setOpen(true)} className="rounded-full p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600" title="إدارة الردود"><Settings2 className="h-3.5 w-3.5" /></button>
      <Manage open={open} onOpenChange={setOpen} items={items} onSaved={setItems} />
    </div>
  );
};
